<template>
  <el-dialog
    :modelValue="visible"
    top="5vh"
    style="width: 96%"
    center
    @close="emit('close-modal')"
  >
    <div class="modal-body">
      <div class="dialog-content">
        <div class="header">
          <h2>{{ title }}</h2>
          <el-button
            type="primary"
            :disabled="!selectedItems.length"
            size="default"
            style="position: absolute; right: 0"
            @click="create"
            >{{ primaryActionLabel }}</el-button
          >
        </div>
      </div>
      <OrderImportFilters class="modal-filters" />
      <OrderImportTable
        class="table-flex"
        :pedidos="pedidos"
      />
    </div>
  </el-dialog>
</template>

<script setup>
import {
  onBeforeMount,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { useOrderImportStore } from '@/views/order_import/stores/order_import_store';
import OrderImportTable from '@/views/order_import/components/order_import_table.vue';
import OrderImportFilters from '@/views/order_import/order_import_list/order_import_filters.vue';

const route = useRoute();
const orderImportStore = useOrderImportStore();
const { pedidos, selectedItems } = storeToRefs(orderImportStore);

const props = defineProps({
  title: { type: String, default: 'Seleccionar pedido' },
  visible: { type: Boolean, default: false },
});

const emit = defineEmits(['close-modal', 'orders-selected']);

const primaryActionLabel = computed(() => {
  if (orderImportStore.flowAction(route) === 'import') {
    return 'Importar';
  }
  return 'Generar OP';
});

const create = async () => {
  emit('close-modal');
  emit('orders-selected');
};

onBeforeMount(() => {
  orderImportStore.clearSelectedItems();
});
</script>

<style scoped>
.modal-body {
  height: calc(90vh - 100px);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.modal-filters {
  flex-shrink: 0;
}

.table-flex {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.dialog-content {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  padding: 16px;
  position: relative;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
